import { render } from "./MySidebar.vue?vue&type=template&id=ef50b570"
import script from "./MySidebar.vue?vue&type=script&lang=js"
export * from "./MySidebar.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__